import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Vuetify stílusok importálása
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import "@mdi/font/css/materialdesignicons.css";
import './styles/app.css'; // Arculati tokenek és globális stílus

const himzoTheme = {
    dark: false,
    colors: {
        background: '#F6EEE2',
        surface: '#FFFFFF',
        primary: '#E24C82',
        'primary-darken-1': '#C43A6B',
        secondary: '#3F7D3A',
        'secondary-darken-1': '#2F5E2C',
        accent: '#F2A93C',
        info: '#3F7D3A',
        success: '#3F7D3A',
        warning: '#F2A93C',
        error: '#D64545',
        'on-background': '#33291F',
        'on-surface': '#33291F',
        'on-primary': '#FFFFFF',
        'on-secondary': '#FFFFFF',
    }
};

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'himzoTheme',
        themes: {
            himzoTheme,
        },
    },
    defaults: {
        VBtn: {
            rounded: 'lg',
            style: 'text-transform: none; font-weight: 600; letter-spacing: 0;',
        },
        VCard: {
            rounded: 'xl',
        },
    },
});

createApp(App).use(store).use(router).use(vuetify).mount('#app')
